export const makeCityOptionId = (country: string, city: string) => `${country}.${city}`;

export const readOptionCityId = (id: string) => {
  const [country, city] = id.split('.');

  return { country, city };
};
